import type { RootState } from "@/store/rootReducer";
import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useSelector } from "react-redux";

interface TableSkeletonProps {
  columns: { name: string; width?: string }[];
  rows?: number;
}

const TableSkeleton: React.FC<TableSkeletonProps> = ({ columns, rows = 8 }) => {
  const { sidebarOpen } = useSelector((state: RootState) => state.global);

  const gridTemplate = columns.map((c) => Number(c.width) - 100 || "1fr").join(" ");

  return (
    <div
      className="bg-white flex flex-col"
      style={{
        width: "100%",
        maxHeight: "calc(100vh - 15.75rem)",
        padding: "12px 16px",
        overflowX: "auto",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: gridTemplate,
          gap: "16px",
          padding: "10px 0",
          borderBottom: "1px solid #ebedf2",
        }}
      >
        {columns.map((col, index) => (
          <div
            key={index}
            className="font-['Roboto',sans-serif] text-[#0000008a] text-[12px] font-bold"
          >
            {col.name}
          </div>
        ))}
      </div>

      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div
          key={rowIndex}
          style={{
            display: "grid",
            gridTemplateColumns: gridTemplate,
            gap: "16px",
            padding: "12px 0",
            borderBottom: "1px solid #f7f7f7",
          }}
        >
          {columns.map((_, colIndex) => (
            <Skeleton
              key={colIndex}
              height={25}
              borderRadius={2}
              baseColor="#e5e7eb"
              highlightColor="#f3f4f6"
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default TableSkeleton;
